import React from 'react';
import { TypedMemo } from '../../common/types';
import styles from './SMLCardGrid.module.scss';

/** The card grid shared by the Smartlinks landing page and the full list. */
const SMLCardGridComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles.grid}>{children}</div>;
};

export const SMLCardGrid = TypedMemo(SMLCardGridComponent);
